import React from "react";
import { Helmet } from "react-helmet";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";

function Home() {
  return (
    <section>
      <Helmet>
        <title>Nisham Ghimire | Portfolio</title>
        <meta name="description" content="Welcome to my portfolio website. Learn more about me and my work." />
        {/* Add any other necessary meta tags for SEO optimization */}
      </Helmet>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row style={{ alignItems: "center", minHeight: "80vh", paddingLeft: "10px", paddingRight: "10px" }}>
            <Col md={6} sm={12} xs={12} className="home-header" style={{
              paddingLeft: "30px",
              paddingRight: "60px",
              paddingBottom: "30px",
              paddingTop: "30px",
              textAlign: "center"
            }}>
              <h1 style={{ paddingBottom: 15, marginBottom: 10 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>
              <h1 className="heading-name" style={{ marginTop: 0, marginBottom: 20 }}>
                I'M
                <strong className="main-name"> Nisham Ghimire</strong>
              </h1>
              <p style={{
                fontSize: "0.95em",
                fontStyle: "italic",
                background: "linear-gradient(90deg, #00c6ff, #f072b6)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
                paddingLeft: "0px",
                marginTop: "10px",
                marginBottom: "30px",
                fontWeight: "bold",
                lineHeight: "1.6"
              }}>
                Available for new opportunities and exciting projects
              </p>
              <div style={{ paddingLeft: "0px", paddingRight: "0px", textAlign: "center", marginTop: "20px" }}>
                <Type />
              </div>
            </Col>
            <Col md={6} sm={12} xs={12} style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingBottom: "30px",
              paddingTop: "30px",
              paddingLeft: "60px",
              paddingRight: "30px"
            }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "500px", width: "100%", maxWidth: "450px", objectFit: "contain" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}
export default Home;
